import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';
import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { AuthService } from './core/auth/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // 로그인 후 첫 화면 전환 지연을 없앤다 — lazy 청크를 idle 시점에 미리 받는다.
    // 스크롤 복원: 문서가 스크롤하므로 화면을 옮기면 맨 위로, 뒤로가기는 이전 위치로 돌린다
    // (없으면 목록 아래까지 내린 상태에서 탭을 바꿨을 때 새 화면이 중간부터 보인다)
    provideRouter(
      routes,
      withComponentInputBinding(),
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
    ),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    // 가드 평가 전에 저장 토큰 검증(/auth/me + /menus)을 끝낸다 — 새로고침 세션 유지
    provideAppInitializer(() => inject(AuthService).restore()),
  ],
};
